import React, { useState, useEffect, useMemo } from "react";
import { Container, ContainerFW } from "../../global";
import { Img } from "../../Img";
import { usePageViewStyle } from "../../../hooks";
import { IconChevronRight } from "../../../Components/svgIcons/chevronRight";
import { StatsValuesRibbon } from "./StatsValuesRibbon/StatsValuesRibbon";
import { ButtonSection } from "./ButtonSection/ButtonSection";
import { AnimationSection } from "./AnimationSection/AnimationSection";
import { CryptoDisclaimer } from "./CryptoDisclaimer/CryptoDisclaimer";
import { conditionallyCreateStyleObj, getClassConditionalAppend, getContainerClassPerMaxWidth } from "../../../utils";
const LINK_BUTTON_STYLE_CLASS_NAME = "HeroBannerHomepageUplift__link--buttonless-link";
export const HeroBannerWithImagesHomeUplift = ({ title, title2, subtitle, titleColor, title2Color, subtitleColor, desktopImage, mobileImage, buttonLabel, buttonHref, buttonHrefMobile, buttonOpenInNewTab, linkHref, linkLabel, linkButtonDesign, linkIcon, backgroundColor, actionMessageLink, actionMessageBadge, actionMessageText, actionMessageLinkInNewTab, animationSrc, animationStateMachines, videoUrl, overlayMediaUrl, statValues, mobileTitleAlignment, tabletTitleAlignment, desktopTitleAlignment, mobileTitle2Alignment, tabletTitle2Alignment, desktopTitle2Alignment, mobileSubTitleAlignment, tabletSubTitleAlignment, desktopSubTitleAlignment, showArrowRight, cryptoDisclaimerContent, logo, hasBackgroundStreaksEffect = true, containerMaxWidth = "1128px", ctaButtonsDirection = "horizontal", textContentHasMaxWidth = true }) => {
    const [buttonUrl, setButtonUrl] = useState(buttonHref);
    const { isLarge } = usePageViewStyle();
    const [imageEl, setImageEl] = useState(undefined);
    useEffect(() => {
        let imgElement = undefined;
        if (isLarge) {
            if (desktopImage) {
                imgElement = React.createElement(Img, { src: desktopImage, alt: title, loading: "eager" });
            }
        }
        else {
            if (mobileImage) {
                imgElement = React.createElement(Img, { src: mobileImage, alt: title, loading: "eager" });
            }
        }
        if (!imgElement) {
            return;
        }
        setImageEl(imgElement);
    }, [isLarge, desktopImage, mobileImage, title]);
    useEffect(() => {
        setButtonUrl((!isLarge && buttonHrefMobile) ? buttonHrefMobile : buttonHref);
    }, [isLarge, buttonHrefMobile, buttonHref]);
    const mainClassName = (() => {
        let mainClassName = `${backgroundColor === "White" ? "HeroBannerHomepageUplift white-background" : "HeroBannerHomepageUplift"}`;
        if (logo?.logoUrl) {
            mainClassName += " HeroBannerHomepageUplift--with-logo";
            if (logo.logoPushesImageDownOnDesktop) {
                mainClassName += " HeroBannerHomepageUplift--with-logo-bar";
            }
        }
        if (ctaButtonsDirection === "vertical") {
            mainClassName += " HeroBannerHomepageUplift--vertical-cta-buttons";
        }
        if (!textContentHasMaxWidth) {
            mainClassName += " HeroBannerHomepageUplift--text-content-width-unconstrained";
        }
        return mainClassName;
    })();
    const showActionMessage = () => (actionMessageText && actionMessageLink) &&
        React.createElement("a", { href: actionMessageLink, target: actionMessageLinkInNewTab ? "_blank" : "_self", className: "HeroBannerHomepageUplift__action-message", rel: "noreferrer" },
            actionMessageBadge && React.createElement("span", { className: "badge" }, actionMessageBadge),
            actionMessageText,
            IconChevronRight);
    const handleButtonStatsBanner = useMemo(() => {
        if (buttonLabel && buttonHref) {
            const finalLinkButtonDesign = linkButtonDesign === LINK_BUTTON_STYLE_CLASS_NAME ? undefined : linkButtonDesign;
            const linkClassName = linkButtonDesign === LINK_BUTTON_STYLE_CLASS_NAME ? LINK_BUTTON_STYLE_CLASS_NAME : undefined;
            return (React.createElement("div", { className: "buttonsWrapper" },
                React.createElement(ButtonSection, { showArrowRight: showArrowRight, buttonLabel: buttonLabel, buttonHref: buttonUrl, linkHref: linkHref, linkLabel: linkLabel, linkButtonDesign: finalLinkButtonDesign, linkClassName: linkClassName, linkIcon: linkIcon, buttonOpenInNewTab: buttonOpenInNewTab })));
        }
        return (Array.isArray(statValues) &&
            React.createElement("div", { className: "options-wrapper" }, statValues.map((a) => (React.createElement(StatsValuesRibbon, { key: `unique${a.title}`, ...a })))));
    }, [buttonHref, buttonLabel, buttonOpenInNewTab, buttonUrl, linkButtonDesign, linkHref, linkIcon, linkLabel, showArrowRight, statValues]);
    const containerMaxWidthClass = getContainerClassPerMaxWidth(containerMaxWidth);
    const containerExtraClass = getClassConditionalAppend(containerMaxWidthClass);
    const getCustomStyleObj = () => conditionallyCreateStyleObj({
        "--title-color": titleColor,
        "--title2-color": title2Color,
        "--subtitle-color": subtitleColor,
        "--mobile-title-alignment": mobileTitleAlignment,
        "--tablet-title-alignment": tabletTitleAlignment,
        "--desktop-title-alignment": desktopTitleAlignment,
        "--mobile-title2-alignment": mobileTitle2Alignment,
        "--tablet-title2-alignment": tabletTitle2Alignment,
        "--desktop-title2-alignment": desktopTitle2Alignment
    });
    const customStyleObj = getCustomStyleObj();
    return (React.createElement("div", { className: mainClassName, style: customStyleObj },
        React.createElement(ContainerFW, { className: containerExtraClass, backgroundColor: backgroundColor },
            hasBackgroundStreaksEffect && React.createElement("div", { className: "streaks-container" },
                React.createElement("div", { className: "streaks" },
                    React.createElement("div", { className: "streak1" }),
                    React.createElement("div", { className: "streak2" }),
                    React.createElement("div", { className: "streak3" }))),
            React.createElement("div", { className: "HeroBannerHomepageUplift__container" },
                React.createElement(Container, { className: containerExtraClass },
                    logo?.logoUrl && React.createElement("div", { className: "HeroBannerHomepageUplift__logo" },
                        React.createElement("img", { src: logo.logoUrl, alt: logo.logoAlt })),
                    React.createElement("div", { className: "HeroBannerHomepageUplift__content" },
                        showActionMessage(),
                        React.createElement("h1", { className: "h1-v2dot6 titleWrapper__title", dangerouslySetInnerHTML: {
                                __html: title,
                            } }),
                        title2 && React.createElement("h5", { className: "h5-v2dot6 titleWrapper__title2", dangerouslySetInnerHTML: {
                                __html: title2,
                            } }),
                        React.createElement("div", { className: "titleWrapper__subtitle", dangerouslySetInnerHTML: {
                                __html: subtitle,
                            }, style: {
                                "--mobile-subTitle-alignment": mobileSubTitleAlignment,
                                "--tablet-subTitle-alignment": tabletSubTitleAlignment,
                                "--desktop-subTitle-alignment": desktopSubTitleAlignment
                            } }),
                        handleButtonStatsBanner,
                        cryptoDisclaimerContent && React.createElement(CryptoDisclaimer, { content: cryptoDisclaimerContent })),
                    React.createElement(AnimationSection, { imageEl: imageEl, animationSrc: animationSrc, animationStateMachines: animationStateMachines, videoUrl: videoUrl, overlayMediaUrl: overlayMediaUrl }))))));
};
